<template>
  <div class="flex w-full justify-start items-center">
    <div class="flex items-center mr-2 ">
      <div
        class="material-icons"
        style="font-size: 16px;"
        :style="{
          color:
            this.params.data.display_status === 4
              ? AISEA_COLOR.LIGHT_BLUE
              : null,
        }"
      >
        {{ statusIcon }}
      </div>
    </div>
    <div class="aisea-text-16-400-black">
      {{ params.value }}
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";

export default {
  name: "CellRendererTimesheetStatus",
  mixins: [ColorMixin],
  data() {
    return {
      statusIconMap: {
        2: "remove", // '未申請', // 'UN_APPLIED',
        3: "arrow_upward", // '申請中', // 'APPLYING',
        4: "check_circle", // '承認済', // 'APPROVED',
        5: "reply", // '差戻し', // 'REMAND',
        6: "remove", // '作業予定'// 'SCHEDULED'
      },
    };
  },
  computed: {
    statusIcon() {
      return this.statusIconMap[this.params.data.display_status];
    },
  },
  created() {},
};
</script>
